import { useContext } from "react";
import { NavItem } from "../../layout";
import {
  ChartSpline,
  Home,
  Package,
  Settings,
  ShoppingCart,
  TrendingUp,
  Users,
  Wallet,
} from "lucide-react";
import { AppContext } from "App";

const NavMenu = () => {
  const { access } = useContext(AppContext);

  return (
    <div>
      {access.dashboardAccess && (
        <NavItem
          title="Home"
          path="home"
          icon={<Home className="text-[22px] text-slate-600" />}
        />
      )}

      {(access.posAccess || access.salesHistoryAccess) && (
        <NavItem
          title="Sales"
          icon={<TrendingUp className="text-[22px] text-slate-600" />}
          child={[
            ...(access.posAccess
              ? [
                  {
                    title: "POS",
                    path: "pos",
                  },
                  ...(access.pos?.registerClosing
                    ? [
                        {
                          title: "Close Register",
                          path: "close_reg",
                        },
                      ]
                    : []),
                  ...(access.pos?.quote
                    ? [
                        {
                          title: "Quotation Sales",
                          path: "quotes",
                        },
                      ]
                    : []),
                ]
              : []),
            ...(access.salesHistoryAccess
              ? [
                  {
                    title: "Sales History",
                    path: "sales_history",
                  },
                ]
              : []),
          ]}
        />
      )}

      {access.cashMgmtAccess && (
        <NavItem
          title="Accounts"
          icon={<Wallet className="text-[22px] text-slate-600" />}
          child={[
            ...(access.cashMgmtAccess
              ? [
                  {
                    title: "Cash Management",
                    path: "cash_management",
                  },
                  {
                    title: "Debit Note",
                    path: "debit_note",
                  },
                  {
                    title: "Credit Note",
                    path: "credit_note",
                  },
                  {
                    title: "Journal Voucher",
                    path: "journal_voucher",
                  },
                  {
                    title: "Chart of Accounts",
                    path: "chart_of_accounts",
                  },
                ]
              : []),
          ]}
        />
      )}

      {(access.printLabelAccess ||
        access.catalogAccess ||
        access.categoryAccess ||
        access.brandAccess ||
        access.tagAccess ||
        access.productAttributeAccess) && (
        <NavItem
          title="Inventory"
          icon={<Package className="text-[22px] text-slate-600" />}
          child={[
            ...(access.catalogAccess
              ? [
                  {
                    title: "Products",
                    path: "products",
                  },
                ]
              : []),
            ...(access.printLabelAccess
              ? [
                  {
                    title: "Print Labels",
                    path: "print_label_history",
                  },
                ]
              : []),
            ...(access.categoryAccess
              ? [
                  {
                    title: "Category",
                    path: "product_category",
                  },
                ]
              : []),
            ...(access.brandAccess
              ? [
                  {
                    title: "Brands",
                    path: "brands",
                  },
                ]
              : []),
            ...(access.tagAccess
              ? [
                  {
                    title: "Tags",
                    path: "tags",
                  },
                ]
              : []),
            ...(access.productAttributeAccess
              ? [
                  {
                    title: "Product Attributes",
                    path: "product_attributes",
                  },
                ]
              : []),
          ]}
        />
      )}

      {(access.supplierAccess ||
        access.stockAccess ||
        access.stockReturnAccess) && (
        <NavItem
          title="Purchase"
          icon={<ShoppingCart className="text-[22px] text-slate-600" />}
          child={[
            ...(access.supplierAccess
              ? [
                  {
                    title: "Suppliers",
                    path: "suppliers",
                  },
                ]
              : []),
            ...(access.stockAccess
              ? [
                  {
                    title: "Stock Control",
                    path: "stock_control",
                  },
                ]
              : []),
            ...(access.stockReturnAccess
              ? [
                  {
                    title: "Return Stock",
                    path: "return_stock",
                  },
                ]
              : []),
          ]}
        />
      )}

      {(access.inqueryAccess ||
        access.customerAccess ||
        access.customerGroupAccess ||
        access.followUpTypeAccess ||
        access.inquerySourceAccess) && (
        <NavItem
          title="CRM"
          icon={<Users className="text-[22px] text-slate-600" />}
          child={[
            ...(access.inqueryAccess
              ? [
                  {
                    title: "Inquiries",
                    path: "inquiries",
                  },
                ]
              : []),
            ...(access.customerAccess
              ? [
                  {
                    title: "Customers",
                    path: "customers",
                  },
                ]
              : []),
            ...(access.customerGroupAccess
              ? [
                  {
                    title: "Customers Group",
                    path: "customer_groups",
                  },
                ]
              : []),
            ...(access.followUpTypeAccess
              ? [
                  {
                    title: "Follow-Up Types",
                    path: "fullow_up_types",
                  },
                ]
              : []),
            ...(access.inquerySourceAccess
              ? [
                  {
                    title: "Inquery Sources",
                    path: "inquery_sources",
                  },
                ]
              : []),
          ]}
        />
      )}

      {access.reportAccess && (
        <NavItem
          title="Reports"
          icon={<ChartSpline className="text-[22px] text-slate-600" />}
          child={[
            ...(access.report?.profitAndLoss
              ? [
                  {
                    title: "Profit and Loss",
                    path: "profit_and_loss_report",
                  },
                ]
              : []),
            ...(access.report?.creditCustomer
              ? [
                  {
                    title: "Credit Customer",
                    path: "credit_customer_report",
                  },
                ]
              : []),
            ...(access.report?.productMovement
              ? [
                  {
                    title: "Product Movement",
                    path: "product_movement_report",
                  },
                ]
              : []),
            ...(access.report?.trialBalance
              ? [
                  {
                    title: "Trial Balance",
                    path: "trial_balance_report",
                  },
                ]
              : []),
          ]}
        />
      )}

      {(access.generalAccess ||
        access.status ||
        access.userRoleAccess ||
        access.outletAccess ||
        access.paymentTypeAccess ||
        access.currencyAccess ||
        access.taxRateAccess ||
        access.userAccess) && (
        <NavItem
          title="Settings"
          icon={<Settings className="text-[22px] text-slate-600" />}
          child={[
            ...(access.generalAccess
              ? [
                  {
                    title: "General",
                    path: "settings_form",
                  },
                ]
              : []),
            ...(access.outletAccess
              ? [
                  {
                    title: "Outlets",
                    path: "outlets",
                  },
                ]
              : []),
            ...(access.paymentTypeAccess
              ? [
                  {
                    title: "Payment Types",
                    path: "payment_types",
                  },
                ]
              : []),
            ...(access.currencyAccess
              ? [
                  {
                    title: "Currency",
                    path: "currencies",
                  },
                ]
              : []),
            ...(access.taxRateAccess
              ? [
                  {
                    title: "Taxes",
                    path: "taxes",
                  },
                ]
              : []),
            ...(access.userAccess
              ? [
                  {
                    title: "Users",
                    path: "users",
                  },
                ]
              : []),
            ...(access.userRoleAccess
              ? [
                  {
                    title: "User Roles",
                    path: "user_roles",
                  },
                ]
              : []),
            ...(access.status
              ? [
                  {
                    title: "Status",
                    path: "status",
                  },
                ]
              : []),
          ]}
        />
      )}
    </div>
  );
};

export default NavMenu;
